import * as fromDatatype from '../../../../models/datatype-library';

export class EntityOutstandingDtoModel {
    entity_guid: fromDatatype.GuidDataFieldInterface;
    customer_code: fromDatatype.VarcharDatatypeInterface;
    supplier_code: fromDatatype.VarcharDatatypeInterface;
    employee_code: fromDatatype.VarcharDatatypeInterface;
    merchant_code: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.VarcharDatatypeInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    comp_name: fromDatatype.VarcharDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    total_pns: fromDatatype.NumericDatatypeInterface;
    total_stlm: fromDatatype.NumericDatatypeInterface;
    total_doc_open: fromDatatype.NumericDatatypeInterface;
    total_contra: fromDatatype.NumericDatatypeInterface;
    total_bal: fromDatatype.NumericDatatypeInterface;
}